/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */

import {scalar} from '@tensorflow/tfjs-core';

import {deregisterOp, getRegisteredOp, registerOp} from './register';

describe('register custom op', () => {
  describe('registerCustomOp', () => {
    it('should auto fill missing fields', () => {
      const executor = () => scalar(1);
      registerOp('newOp', executor);
      const opMapper = getRegisteredOp('newOp');
      expect(opMapper.tfOpName).toEqual('newOp');
      expect(opMapper.category).toEqual('custom');
      expect(opMapper.inputs).toEqual([]);
      expect(opMapper.attrs).toEqual([]);
      expect(opMapper.customExecutor).toEqual(executor);
      deregisterOp('newOp');
    });
  });
  describe('deregisterOp', () => {
    it('should remove the custom op', () => {
      registerOp('newOp', () => scalar(1));
      expect(getRegisteredOp('newOp')).toBeDefined();
      deregisterOp('newOp');
      expect(getRegisteredOp('newOp')).not.toBeDefined();
    });
  });
});
